import atlasApiService from './atlas_api_service';

class AtlasLocationService {
  // Gets a location from (lat, lng)
  geocode(lat, lng) {
    return atlasApiService.geocode(lat, lng);
  }

  // Gets place autocomplete suggestions
  getPlacePredictions(input) {
    return atlasApiService.getPlacePredictions(input);
  }

  // Get lat, lng details from a placeId. This is used because getPlacePredictions method doesn't return (lat, lgn)
  geocodeFromPlace(placeId) {
    return atlasApiService.geocodeFromPlace(placeId);
  }

  cleanAddress(address) {
    return address && address
      .replace(/, Brasil$/i, '')
      .replace(/(,\s)?\d{5}-\d{3}/, ''); // Zip codes like 12345-123
  }
}

export default new AtlasLocationService();
